// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "../controllers"
import '../stylesheets/application.scss';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import "chartkick/chart.js"
import DataTable from 'datatables.net-dt';

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";

Rails.start();
Turbolinks.start();

function initializeFlatpickr() {
  const dateInputs = document.querySelectorAll(".datepicker");

  if (dateInputs.length > 0) {
    flatpickr(".datepicker", {
      locale: {
        firstDayOfWeek: 1
      }
    });
  }
}

function initializeDataTables() {
  new DataTable('.sortable-table');
}

document.addEventListener("turbo:load", initializeFlatpickr);
document.addEventListener("turbolinks:load", initializeFlatpickr);
document.addEventListener("turbo:load", initializeDataTables);
document.addEventListener("turbolinks:load", initializeDataTables);

document.addEventListener("turbo:before-visit", () => {
  const dateInputs = document.querySelectorAll(".datepicker");

  for (let i = 0; i < dateInputs.length; i++) {
    const flatpickrInstance = dateInputs[i]._flatpickr;

    if (flatpickrInstance) {
      flatpickrInstance.destroy();
    }
  }
});
